import * as React from 'react';
import DataTable from 'react-data-table-component';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import IProps from '../props/ITableEssentialResiduesComponentProps';

import {
    columnsEssentialResidues,
    columnsEssentialResidueDetails,
} from '../../../TableColumns';

function TableEssentialResidues(props: IProps) {
    const [modal, setModal] = React.useState<number | null>(null);
    const closeModal = () => setModal(null);

    const handleChange = (rows) => {
        props.setSelectedSiteAnotations(rows.selectedRows);
    };

    return (
        <>
            <DataTable
                columns={[
                    ...columnsEssentialResidues,
                    {
                        name: 'Details',
                        cell: (row, index) => (
                            <Button
                                style={{ width: '40%', marginLeft: '5%', marginRight: '5%' }}
                                onClick={() => setModal(index)}>
                                <img
                                    src='images/book.png'
                                    style={{ width: '100%' }}
                                    alt='Show details.'></img>
                            </Button>
                        ),
                        button: true,
                    },
                ]}
                data={props.PositionSpecificData}
                onSelectedRowsChange={(r) => handleChange(r)}
                selectableRows
                pagination
                highlightOnHover={true}
                selectableRowsHighlight={true}
                dense
            />

            {modal !== null && (
                <Modal isOpen={true} centered={true} fade={false} toggle={closeModal}>
                    <ModalHeader toggle={closeModal}>
                        {props.AllEssentialResiduesData[modal].residue}
                    </ModalHeader>
                    <ModalBody>
                        <DataTable
                            columns={[
                                ...columnsEssentialResidueDetails,
                                {
                                    name: 'Details',
                                    cell: (row, index) => (
                                        <a
                                            href={
                                                'https://www.uniprot.org/uniprotkb/' +
                                                row.referenceEntry +
                                                '/entry'
                                            }
                                            target='_blank'>
                                            Source
                                        </a>
                                    ),
                                    button: true,
                                },
                            ]}
                            data={props.AllEssentialResiduesData.filter((obj) => {
                                return (
                                    obj.residue ===
                                        props.AllEssentialResiduesData[modal].residue &&
                                    obj.chain == props.AllEssentialResiduesData[modal].chain
                                );
                            })}
                            pagination
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={closeModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
}

export default TableEssentialResidues;
